export default __webpack_public_path__ + "static/media/flagsXL.279b1021.jpg";